import styled from 'styled-components';

const BgImage = styled.div`
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  filter: grayscale(100%) saturate(2) contrast(1.5);
  height: ${({ height = '300px' }) => height};
  width: 100%;
  transition: all 0.5s ease;

  &:hover {
    filter: none;
    transition: all 0.5s ease;
    zindex: 1001;
  }
`;

export default BgImage;
